import React from 'react'
import styled from 'styled-components'

import { PlanInterface } from 'src/interfaces/plan'
import basePriceImg from 'src/assets/images/members/mypage/base_price.png'
import ButtonCustom from 'src/components/form/Button'
import { useNavigate } from 'react-router-dom'
import { formatNumPrice } from 'src/utils/helper'
import LocalStorage from 'src/utils/LocalStorage'
import { PLAN_TYPE } from 'src/constants/app'
import { PLAN_PAYMENT_TYPE } from 'src/constants/plan'
import LazyLoadImage from 'src/components/common/LazyLoadImage'

type PlanInfoInterface = {
  plans?: PlanInterface[]
  planFromLp?: PlanInterface | null
  planImportants?: PlanInterface[]
  activePlan?: PlanInterface
  changedPlanId?: number
  selectPlan: Function
  planTypeBefore: string
  feedbackId?: number
  showRecommendPlans?: boolean
  hasSuggestPlanLp?: boolean
  setShowRecommendPlans?: (b: boolean) => void
  disabledButton?: boolean
}

const PlanInfoComponent = (props: PlanInfoInterface) => {
  const {
    plans = [],
    planFromLp,
    planImportants = [],
    activePlan,
    changedPlanId,
    selectPlan,
    planTypeBefore,
    feedbackId,
    showRecommendPlans,
    hasSuggestPlanLp,
    setShowRecommendPlans,
    disabledButton = false,
  } = props
  const navigate = useNavigate()

  const handleShowDetail = (id) => {
    LocalStorage.setActivePlan(id)
    LocalStorage.setPlanType(planTypeBefore)
    if (feedbackId && planTypeBefore === PLAN_TYPE.PRESCRIPTION) {
      navigate(`/plans/${id}?feedbackId=${feedbackId}`)
    } else {
      navigate(`/plans/${id}`)
    }
  }

  const handleShowRecommendPlan = () => {
    if (setShowRecommendPlans) {
      setShowRecommendPlans(!showRecommendPlans)
    }
  }

  return (
    <Wrapper>
      <div className="info-plan" id="choosing">
        <div
          className={`info-plan__choosing ${
            planTypeBefore === PLAN_TYPE.BUY_SHAMPOO_SUBSCRIPTION
              ? 'pt-150'
              : ''
          }`}
        >
          {planImportants && planImportants.length > 0 && (
            <div className="info-plan__recommended-box">
              <h3 className="info-plan__recommended-title">
                赤枠のオススメのお薬は、医師が診察時あなたに合うと考えて選んだオススメの薬になります
              </h3>
              {planImportants.map((plan) => {
                return (
                  <>
                    <div
                      key={`important-plan-${plan.id}`}
                      className={`info-plan__choosing-plan${
                        plan.pivot?.recommended || plan.recommended
                          ? ' recommended'
                          : ''
                      }`}
                    >
                      <div
                        className={`info-plan__choosing-content ${
                          activePlan && plan.id === activePlan.id
                            ? 'active'
                            : ''
                        } ${
                          plan.pivot?.recommended || plan.recommended
                            ? 'recommended'
                            : ''
                        } ${plan.id === changedPlanId ? 'changed' : ''}`}
                        onClick={() => selectPlan(plan)}
                      >
                        <div className="info-plan__choosing-header">
                          <div className="info-plan__choosing-title">
                            <p>{plan.name}</p>
                            {plan.id === changedPlanId && (
                              <p className="info-plan__choosing-badge">
                                変更予定プラン
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="info-plan__img mb-10">
                          <LazyLoadImage imgSrc={plan.image_url} />
                        </div>

                        {plan.payment_type === PLAN_PAYMENT_TYPE.ONCE ? (
                          <div className="info-plan__choosing-header-right fs-14">
                            <span className="info-plan__choosing-header-price">
                              {plan.price_first
                                ? formatNumPrice(plan.price_first)
                                : 0}
                            </span>
                            円(税込) /回
                          </div>
                        ) : plan.payment_type === PLAN_PAYMENT_TYPE.REGULAR &&
                          plan.price_first === plan.price_after ? (
                          <div className="info-plan__choosing-header-right fs-14">
                            <span className="info-plan__choosing-header-price">
                              {plan.price_first
                                ? formatNumPrice(plan.price_first)
                                : 0}
                            </span>
                            円(税込) /
                            <span className="word-break-keep-all">{`${
                              plan.cycle ?? '-'
                            }日`}</span>
                          </div>
                        ) : (
                          <div className="info-plan__choosing-header-right fs-14 choosing-more p-0">
                            <div>
                              <p className="mb-0 work-bread-all fs-16">
                                <span className="info-plan__choosing-header-after">
                                  初回&nbsp;&nbsp;&nbsp;
                                  {plan.price_first
                                    ? formatNumPrice(plan.price_first)
                                    : 0}
                                </span>
                                円/
                                <span className="word-break-keep-all">{`${
                                  plan.cycle ?? '-'
                                }日`}</span>
                              </p>
                              <p className="info-plan__choosing-header-price">
                                <span className="fs-16">２回目以降 &nbsp;</span>
                                <span className="fs-26">
                                  {plan.price_after
                                    ? formatNumPrice(plan.price_after)
                                    : 0}
                                </span>
                                <span className="fs-16">円(税込)</span>
                              </p>
                            </div>
                          </div>
                        )}

                        <ButtonCustom
                          className="btnDetailMenu btn-default btn-chestnut-rose mt-20 mgc fw-700"
                          loading={false}
                          disabled={disabledButton}
                          onClick={() => handleShowDetail(plan.id)}
                          htmlType="button"
                          name="このプランにする"
                        />
                      </div>
                    </div>
                  </>
                )
              })}
              {hasSuggestPlanLp && !planFromLp && plans && plans.length > 0 && (
                <ButtonCustom
                  className="btnDetailMenu btn-default btn-gurkha mt-20 mgc fw-700"
                  loading={false}
                  disabled={false}
                  onClick={handleShowRecommendPlan}
                  htmlType="button"
                  name="ご提案の処方プランはこちら"
                />
              )}
            </div>
          )}
          {planFromLp ? (
            <div className="info-plan__lp-box">
              {planImportants && planImportants.length > 0 && (
                <h3 className="info-plan__lp-title">LPから選んだプラン</h3>
              )}
              <div
                key={`lp-plan-${planFromLp.id}`}
                className="info-plan__choosing-plan"
              >
                <div
                  className={`info-plan__choosing-content ${
                    activePlan && planFromLp.id === activePlan.id
                      ? 'active'
                      : ''
                  } ${planFromLp.id === changedPlanId ? 'changed' : ''}`}
                  onClick={() => selectPlan(planFromLp)}
                >
                  <div className="info-plan__choosing-header">
                    <div className="info-plan__choosing-title">
                      <p>{planFromLp.name}</p>
                      {planFromLp.id === changedPlanId && (
                        <p className="info-plan__choosing-badge">
                          変更予定プラン
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="info-plan__img mb-10">
                    <LazyLoadImage imgSrc={planFromLp.image_url} />
                  </div>

                  {planFromLp.payment_type === PLAN_PAYMENT_TYPE.ONCE ? (
                    <div className="info-plan__choosing-header-right fs-14">
                      <span className="info-plan__choosing-header-price">
                        {planFromLp.price_first
                          ? formatNumPrice(planFromLp.price_first)
                          : 0}
                      </span>
                      円(税込) /回
                    </div>
                  ) : planFromLp.payment_type === PLAN_PAYMENT_TYPE.REGULAR &&
                    planFromLp.price_first === planFromLp.price_after ? (
                    <div className="info-plan__choosing-header-right fs-14">
                      <span className="info-plan__choosing-header-price">
                        {planFromLp.price_first
                          ? formatNumPrice(planFromLp.price_first)
                          : 0}
                      </span>
                      円(税込) /
                      <span className="word-break-keep-all">{`${
                        planFromLp.cycle ?? '-'
                      }日`}</span>
                    </div>
                  ) : (
                    <div className="info-plan__choosing-header-right fs-14 choosing-more p-0">
                      <div>
                        <p className="mb-0 work-bread-all fs-16">
                          <span className="info-plan__choosing-header-after">
                            初回&nbsp;&nbsp;&nbsp;
                            {planFromLp.price_first
                              ? formatNumPrice(planFromLp.price_first)
                              : 0}
                          </span>
                          円/
                          <span className="word-break-keep-all">{`${
                            planFromLp.cycle ?? '-'
                          }日`}</span>
                        </p>
                        <p className="info-plan__choosing-header-price">
                          <span className="fs-16">２回目以降 &nbsp;</span>
                          <span className="fs-26">
                            {planFromLp.price_after
                              ? formatNumPrice(planFromLp.price_after)
                              : 0}
                          </span>
                          <span className="fs-16">円(税込)</span>
                        </p>
                      </div>
                    </div>
                  )}

                  <ButtonCustom
                    className="btnDetailMenu btn-default btn-chestnut-rose mt-20 mgc fw-700"
                    loading={false}
                    disabled={disabledButton}
                    onClick={() => handleShowDetail(planFromLp.id)}
                    htmlType="button"
                    name="このプランにする"
                  />
                </div>
              </div>

              {plans && plans.length > 0 && (
                <ButtonCustom
                  className="btnDetailMenu btn-default btn-gurkha mt-20 mgc fw-700"
                  loading={false}
                  disabled={false}
                  onClick={handleShowRecommendPlan}
                  htmlType="button"
                  name={
                    planTypeBefore === PLAN_TYPE.PRESCRIPTION
                      ? 'ご提案の処方プランはこちら'
                      : '別のプランはこちら'
                  }
                />
              )}
            </div>
          ) : (
            (!planImportants || planImportants.length === 0) &&
            plans &&
            plans.length > 0 &&
            plans.map((plan) => {
              return (
                <div
                  key={`plan-${plan.id}`}
                  className="info-plan__choosing-plan"
                >
                  <div
                    className={`info-plan__choosing-content ${
                      activePlan && plan.id === activePlan.id ? 'active' : ''
                    } ${plan.id === changedPlanId ? 'changed' : ''}`}
                    onClick={() => selectPlan(plan)}
                  >
                    <div className="info-plan__choosing-header">
                      <div className="info-plan__choosing-title">
                        <p>{plan.name}</p>
                        {plan.id === changedPlanId && (
                          <p className="info-plan__choosing-badge">
                            変更予定プラン
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="info-plan__img mb-10">
                      <LazyLoadImage imgSrc={plan.image_url} />
                    </div>

                    {plan.payment_type === PLAN_PAYMENT_TYPE.ONCE ? (
                      <div className="info-plan__choosing-header-right fs-14">
                        <span className="info-plan__choosing-header-price">
                          {plan.price_first
                            ? formatNumPrice(plan.price_first)
                            : 0}
                        </span>
                        円(税込) /回
                      </div>
                    ) : plan.payment_type === PLAN_PAYMENT_TYPE.REGULAR &&
                      plan.price_first === plan.price_after ? (
                      <div className="info-plan__choosing-header-right fs-14">
                        <span className="info-plan__choosing-header-price">
                          {plan.price_first
                            ? formatNumPrice(plan.price_first)
                            : 0}
                        </span>
                        円(税込) /
                        <span className="word-break-keep-all">{`${
                          plan.cycle ?? '-'
                        }日`}</span>
                      </div>
                    ) : (
                      <div className="info-plan__choosing-header-right fs-14 choosing-more p-0">
                        <div>
                          <p className="mb-0 work-bread-all fs-16">
                            <span className="info-plan__choosing-header-after">
                              初回&nbsp;&nbsp;&nbsp;
                              {plan.price_first
                                ? formatNumPrice(plan.price_first)
                                : 0}
                            </span>
                            円/
                            <span className="word-break-keep-all">{`${
                              plan.cycle ?? '-'
                            }日`}</span>
                          </p>
                          <p className="info-plan__choosing-header-price">
                            <span className="fs-16">２回目以降 &nbsp;</span>
                            <span className="fs-26">
                              {plan.price_after
                                ? formatNumPrice(plan.price_after)
                                : 0}
                            </span>
                            <span className="fs-16">円(税込)</span>
                          </p>
                        </div>
                      </div>
                    )}

                    <ButtonCustom
                      className="btnDetailMenu btn-default btn-chestnut-rose mt-20 mgc fw-700"
                      loading={false}
                      disabled={disabledButton}
                      onClick={() => handleShowDetail(plan.id)}
                      htmlType="button"
                      name="このプランにする"
                    />
                  </div>
                </div>
              )
            })
          )}

          {(showRecommendPlans ||
            (!hasSuggestPlanLp &&
              !planFromLp &&
              planImportants &&
              planImportants.length > 0)) &&
            plans &&
            plans.length > 0 &&
            plans.map((plan) => {
              return (
                <div
                  key={`other-plan-${plan.id}`}
                  className="info-plan__choosing-plan"
                >
                  <div
                    className={`info-plan__choosing-content ${
                      activePlan && plan.id === activePlan.id ? 'active' : ''
                    } ${plan.id === changedPlanId ? 'changed' : ''}`}
                    onClick={() => selectPlan(plan)}
                  >
                    <div className="info-plan__choosing-header">
                      <div className="info-plan__choosing-title">
                        <p>{plan.name}</p>
                        {plan.id === changedPlanId && (
                          <p className="info-plan__choosing-badge">
                            変更予定プラン
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="info-plan__img mb-10">
                      <LazyLoadImage imgSrc={plan.image_url} />
                    </div>

                    {plan.payment_type === PLAN_PAYMENT_TYPE.ONCE ? (
                      <div className="info-plan__choosing-header-right fs-14">
                        <span className="info-plan__choosing-header-price">
                          {plan.price_first
                            ? formatNumPrice(plan.price_first)
                            : 0}
                        </span>
                        円(税込) /回
                      </div>
                    ) : plan.payment_type === PLAN_PAYMENT_TYPE.REGULAR &&
                      plan.price_first === plan.price_after ? (
                      <div className="info-plan__choosing-header-right fs-14">
                        <span className="info-plan__choosing-header-price">
                          {plan.price_first
                            ? formatNumPrice(plan.price_first)
                            : 0}
                        </span>
                        円(税込) /
                        <span className="word-break-keep-all">{`${
                          plan.cycle ?? '-'
                        }日`}</span>
                      </div>
                    ) : (
                      <div className="info-plan__choosing-header-right fs-14 choosing-more p-0">
                        <div>
                          <p className="mb-0 work-bread-all fs-16">
                            <span className="info-plan__choosing-header-after">
                              初回&nbsp;&nbsp;&nbsp;
                              {plan.price_first
                                ? formatNumPrice(plan.price_first)
                                : 0}
                            </span>
                            円/
                            <span className="word-break-keep-all">{`${
                              plan.cycle ?? '-'
                            }日`}</span>
                          </p>
                          <p className="info-plan__choosing-header-price">
                            <span className="fs-16">２回目以降 &nbsp;</span>
                            <span className="fs-26">
                              {plan.price_after
                                ? formatNumPrice(plan.price_after)
                                : 0}
                            </span>
                            <span className="fs-16">円(税込)</span>
                          </p>
                        </div>
                      </div>
                    )}

                    <ButtonCustom
                      className="btnDetailMenu btn-default btn-chestnut-rose mt-20 mgc fw-700"
                      loading={false}
                      disabled={disabledButton}
                      onClick={() => handleShowDetail(plan.id)}
                      htmlType="button"
                      name="このプランにする"
                    />
                  </div>
                </div>
              )
            })}
        </div>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  .info-plan {
    .info-plan__choosing {
      /* display: flex;
      justify-content: space-between;
      align-items: stretch;
      align-self: center;
      overflow: scroll; */
      /* margin: auto; */
      color: #000;
      padding-bottom: 30px;
      margin: 20px 20px 0;

      &.pt-150 {
        padding-top: 115px;
      }

      &-content {
        /* min-width: calc(100vw - 45px); */
        /* width: calc(100vw - 60px); */
        width: 100%;
        overflow: hidden;
        /* margin-right: 10px; */
        position: relative;
        font-size: 15px;
        background-color: #fff;
        margin-top: 30px;
        padding-bottom: 20px;

        /* @media (min-width: 767px) {
          width: 360px;
        } */
        &.active {
          border: 4px solid var(--color-chestnut-rose);
        }

        &.recommended {
          border: 5px solid #e01616;
        }

        &.changed {
          border: 5px solid #e01616;
        }
      }

      &-title {
        padding: 10px;
      }

      &-badge {
        display: inline-block;
        margin-top: 6px;
        background: #e01616;
        color: #fff;
        font-size: 12px;
        font-weight: 700;
        padding: 3px 8px;
        border-radius: 4px;
      }

      &-header {
        /* min-height: 60px; */
        font-weight: bold;
        display: flex;
        align-items: stretch;
        align-self: center;
        /* justify-content: center; */

        &-right {
          /* background-color: #998800; */
          color: var(--color-rangoon-green);
          padding: 5px;
          font-size: 13px;
          /* white-space: nowrap; */
          text-align: center;
          display: flex;
          justify-content: center;
          align-items: baseline;
          /* position: absolute; */
          bottom: 0;
          width: 100%;
        }

        &-after {
          color: var(--color-rangoon-green);
        }

        &-price {
          font-size: 22px;
          font-weight: 600;
        }
      }

      &-footer {
        background-color: #f1efe7;
        color: #000;
        font-size: 20px;
        font-weight: bold;
        text-align: center;
        padding: 5px 1px;
        margin-top: 5px;
        position: absolute;
        bottom: 0;
        width: 100%;

        span {
          font-size: 12px;
          font-weight: normal;
        }
      }

      &-text {
        padding: 5px;
      }

      &-plan {
        display: flex;
        justify-content: flex-start;
        align-items: stretch;
        flex-wrap: nowrap;
        align-self: stretch;
      }

      &-left {
        /* background-color: #cfc392; */
        /* padding: 5px; */
        color: #000;
        font-weight: bold;
        /* width: 30%; */
        height: 100%;
      }

      &-right {
        /* width: 100%; */
        text-align: center;
        color: #e01616;
        text-shadow: 2px 0 #fff, -2px 0 #fff, 0 2px #fff, 0 -2px #fff,
          1px 1px #fff, -1px -1px #fff, 1px -1px #fff, -1px 1px #fff;
        background-image: url(${basePriceImg});
        background-repeat: no-repeat;
        background-size: 80% auto;
        background-position: 50% 10px;
      }

      .choosing-more {
        padding: 0;
        justify-content: center;
        align-items: center;
        gap: 10px;
      }

      &-text {
        color: var(--color-chestnut-rose);
        right: 25px;
        top: 50%;
        transform: translate(0, -50%);
        position: absolute;
      }

      &-img {
        height: 60px;
        position: relative;
      }
    }

    &__img {
      /* min-height: 65%; */
      /* margin-bottom: 100px; */
      width: 100%;

      img {
        width: 100%;
      }
    }

    .word-break-keep-all {
      word-break: keep-all;
    }

    .ant-btn-primary:focus {
      border-color: var(--color-gurkha) !important;
      background: var(--color-gurkha) !important;
    }

    .btnDetailMenu {
      max-width: 330px;
    }

    .info-plan__recommended {
      &-title {
        font-weight: 800;
        color: #c20505;
      }

      &-box {
        margin-bottom: 15px;
      }
    }

    .info-plan__lp {
      &-box {
        margin: 0;
      }

      &-title {
        font-weight: 850;
        color: #000000;
      }
    }
  }
`

export default PlanInfoComponent
